.wrapper {
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    &.isIcon {
        width:80px;
    }
  }
  
  .label {
    line-height: 37px;
    position: relative;
    display: flex;
    justify-content: space-between;
    flex-shrink: 0;
    width: 100%;
    height: 35px;
    background: rgba(239, 240, 242, 1);
    border: 1px solid rgba(23, 24, 26, 0.1);
    /*background: var(--color-yellow);*/
    border-radius: 20px;
    cursor: pointer;
    transition: background-color 0.3s ease;
    & span {
        color: var(--color-black-50);
        text-align: center;
        width: 50%;;
    }
  
    &:after {
      
    }
  
    &.isChecked {
      background: rgba(239, 240, 242, 1);
      color: var(--color-black-70);
      transition: background-color 0.3s ease;
        
      & div.toggle {
        transition: transform 0.2s ease;
        transform: translateX(100%);
      }
    }
  
    &:focus-visible {
      outline: none;
    }
  
    &:focus-visible::before {
      content: '';
      position: absolute;
      display: block;
      width: 44px;
      height: 24px;
      top: 50%;
      left: 50%;
      border-radius: 14px;
      transform: translate(-50%, -50%);
      box-shadow: 0px 0px 0px 2px var(--color-yellow);
    }
  }

  .optionLabel {
    display: flex;
    justify-content: center;
    align-items: center;
    &.isDisabled {
      opacity: .2;
    }
  }

  .toggle {
    position: absolute;
    content: '';
    top: 0;
    left: 0;
    width: 50%;
    height: 33px;
    background: white;
    border-radius: 20px;
    border: 1px solid black;
    background: black;
    color:white;
    transition: transform 0.2s ease;
    text-align: left;
    display: flex;
    justify-content: center;
    align-items: center;
    &.isIcon {
      background-color: var(--color-yellow);
      border-color: rgba(232, 186, 3, 1);
    }
    }

    .checkbox {
      position: relative;
      width: 20px;
      height: 20px;
      background-color: rgba(239, 240, 242, 1);
      border:1px solid rgba(23, 24, 26, 0.1);
      border-radius: 50%;
      cursor: pointer;
      transition: background-color 0.2s ease;
      margin-left:10px;
    
      &:focus-visible {
        outline: none;
      }
    
      &:focus-visible:before {
        content: '';
        position: absolute;
        display: block;
        width: 24px;
        height: 24px;
        top: 50%;
        left: 50%;
        border-radius: 50%;
        transform: translate(-50%, -50%);
        box-shadow: 0px 0px 0px 2px var(--color-yellow);
      }
    
      &:after {
        content: '';
        transform: scale(0);
        transition: transform 0.4s ease;
      }
    
      &.isChecked {
        transition: background-color 0.2s ease;
        background-color: var(--color-yellow);
        border:0;
    
        &:after {
          content: '';
          transform: scale(1);
          transition: transform 0.4s ease;
          position: absolute;
          top: 0;
          left: 0;
          display: block;
          width: 20px;
          height: 20px;
          background-image: url("data:image/svg+xml,%3Csvg width='10' height='8' viewBox='0 0 10 8' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M1 3.2L4.29412 6L9 1' stroke='black' stroke-width='2'/%3E%3C/svg%3E%0A");
          background-position: center;
          background-repeat: no-repeat;
        }
      }
    }
  
  .field {
    position: absolute;
    opacity: 0;
  }

  .icon {
    height: 14px;
  }

  .spinner {
    position: absolute;
    top: 60%;
    transform: translateY(-50%);
    right: 10px;
  }
  
  
  